import { Injectable } from '@angular/core';
import { Router } from '@angular/router'

@Injectable()
export class UserService {
  constructor(
    private router: Router
    // private toastService: ToastService
  ) { }

  getUser() {
    return sessionStorage.getItem("user");
  };

  getToken() {
    let token = '';
    let user = JSON.parse(sessionStorage.getItem("user"));
    if(user != null && user.token != null && user.token != ""){
        token = user.token;
    }
    return token;
  };

}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts